import React from 'react';

import {observer} from "mobx-react";
import {TrendsWidgetAsync} from "../../../trends-widget/components/trends-widget.async";
import {ENTITY_TYPES} from "../../../../core/app/consts";
import styles from "../../styles/game-center-widget.module.scss";
import classNames from "classnames";
import {OddsByWidgetAsync} from "../../../odds-by-widget/components/odds-by-widget.async";

export const GameCenterWidgetContentTrendsTab = observer(({controller, matchupId, gameId, location}) => {
  const {state} = controller;
  const {shouldRenderTrends, device: {isSmallView}} = state;

  const trendsProps = {
    entityType: ENTITY_TYPES.game,
    gameId,
    matchupId,
    location,
    className: classNames(styles.trends_container)
  }

  const oddsByWidgetProps = {
    entityId: gameId,
    entityType: ENTITY_TYPES.game,
    className: classNames(styles.odds_by, {[styles.small_view]: isSmallView})
  }

  return (shouldRenderTrends ? <>
    <OddsByWidgetAsync {...oddsByWidgetProps} />
    <TrendsWidgetAsync {...trendsProps}/>
  </> : null)
});
